import { action } from "satcheljs";
import type ConversationReadingPaneViewState from "owa-mail-reading-pane-store/lib/store/schema/ConversationReadingPaneViewState";

export interface TryInitializeShouldShowCLPLabelActionMessage {
    conversationViewState: ConversationReadingPaneViewState;
}
const defaultExport: (conversationViewState: ConversationReadingPaneViewState) => TryInitializeShouldShowCLPLabelActionMessage = action("tryInitializeShouldShowCLPLabel", (conversationViewState: ConversationReadingPaneViewState): TryInitializeShouldShowCLPLabelActionMessage => ({
    conversationViewState,
}));
export default defaultExport;
